import type { SupplierStatus } from '@cpce/database/enums';
import type { BaseSupplier, SupplierChargeAccountLine, TiersAccountState } from '@cpce/shared';
import { commiteeInfiniteQuery, commiteeQuery } from '@/api/queries.utils';
import { suppliersQueryKeys } from './suppliers.query-keys';
import type { SupplierFormatted } from './suppliers.types';

export function useSuppliersInfinite(params: { search?: string; status?: SupplierStatus } = {}) {
  return commiteeInfiniteQuery<BaseSupplier>({
    queryKey: suppliersQueryKeys.infinite(params),
    url: '/commitee/:commiteeId/suppliers',
    params,
  });
}

export function useSupplier(id: number, options?: { enabled?: boolean }) {
  return commiteeQuery<BaseSupplier, SupplierFormatted>({
    queryKey: suppliersQueryKeys.one(id),
    url: `/commitee/:commiteeId/suppliers/${id}`,
    enabled: options?.enabled,
  });
}

export function useSupplierChargeAccountLines(supplierId: number, enabled: boolean) {
  return commiteeQuery<SupplierChargeAccountLine[]>({
    queryKey: suppliersQueryKeys.chargeAccountLines(supplierId),
    url: `/commitee/:commiteeId/suppliers/${supplierId}/charge-account/lines`,
    enabled,
  });
}

export function useSupplierFinancialAccount(id: number) {
  return commiteeQuery<TiersAccountState>({
    queryKey: suppliersQueryKeys.financialAccount(id),
    url: `/commitee/:commiteeId/suppliers/${id}/financial-account`,
  });
}
